import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodes, COMMAND_PRIORITY_EDITOR, createCommand } from 'lexical';
import { useEffect } from 'react';
import { ParameterDto } from '@/Domain/api/Action/dto/Action.dto';
import { ParameterDropdown } from '@/Domain/components/Action/Lexical/component/ParameterDropdown';
import { BadgeNode, boxStyle } from '@/Domain/components/Action/Lexical/node/BadgeNode';

type InsertBadgePluginProps = {
  parameters: ParameterDto[];
};

export const INSERT_BADGE_COMMAND = createCommand<ParameterDto>();
export const InsertBadgePlugin = ({ parameters }: InsertBadgePluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        INSERT_BADGE_COMMAND,
        (param) => {
          const node = new BadgeNode(param.name, param.id, boxStyle.CURLY);
          $insertNodes([node]);
          node.selectNext();
          const key = node.getKey();
          requestAnimationFrame(() => {
            editor.getRootElement()?.focus({ preventScroll: true });
            editor.getElementByKey(key)?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });

          return true;
        },
        COMMAND_PRIORITY_EDITOR,
      ),
    [editor],
  );

  return (
    <ParameterDropdown
      parameters={parameters}
      onSelect={(parameter) => editor.dispatchCommand(INSERT_BADGE_COMMAND, parameter)}
    />
  );
};
